import {ContentWithLevel, EnumDictionary} from "../delme_globals";
import {sendPostRequest} from "../../global/axiosFormWrapper";

type LinkerstellerParams = {
    productWebInt:string,
    sportWebInt:string,
    land:string,
    sprache:string,
    contentArray:ContentWithLevel[],
}
type LinkerstellerParamsWithCallback = {
    productWebInt:string,
    sportWebInt:string,
    land:string,
    sprache:string,
    contentArray:ContentWithLevel[],
    callback:(result)=>void
}

export class Linkersteller {
    public static getInternationalKonfiLinks(params: LinkerstellerParamsWithCallback) {
        Linkersteller.getInternationalKonfiLinksPromise(params).then(result=>params.callback(result))
    }

    public static getInternationalKonfiLinksPromise(params: LinkerstellerParams):Promise<EnumDictionary<string, string>> {

        return new Promise<EnumDictionary<string, string>>(resolve => {
            sendPostRequest("/konfigurator_php/actionmodul/linkErsteller.php",
                {
                    land: params.land,
                    sprache: params.sprache,
                    sport: params.sportWebInt,
                    targetContents: JSON.stringify(params.contentArray, ),
                    product: params.productWebInt
                }).then((response)=>resolve(response.data))
        })


    }
}
